import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import { StorefrontClient } from "@lib/ShiOneClient";
import ms from "ms";

export const EcommerceQueryKeys = {
  OrgUnitNavHeader: "ecommerce-orgunit-nav-header",
} as const;

export type OrgUnitNavHeaderDto = {
  orgUnitId: number;
  /**
   * The storefront/account header name (custom catalog name or account name depending on org unit).
   */
  displayName?: string | null;
  /**
   * The org unit's name (used as the label above Shop Products / Standards / Orders / Quotes).
   */
  orgUnitName?: string | null;
  logoUrl?: string | null;
};


export function useGetOrgUnitNavHeader(orgUnitId: number | null, isEnabled: boolean = true) {
  const resolvedOrgUnitId = orgUnitId ?? 0;

  const api = useApi(StorefrontClient);

  const fetch = async (): Promise<OrgUnitNavHeaderDto | null> => {
    const response = (await api.getOrgUnitNavHeader(
      resolvedOrgUnitId,
    )) as unknown as OrgUnitNavHeaderDto;

    return response ?? null;
  };

  return useQuery({
    queryKey: [EcommerceQueryKeys.OrgUnitNavHeader, resolvedOrgUnitId],
    queryFn: fetch,
    enabled: isEnabled,
    staleTime: ms("15s")
  });
}
